import React from 'react';
import PropTypes from 'prop-types';

const Save02 = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.78125 15.5625V11.3438C4.78125 10.826 5.20098 10.4062 5.71875 10.4062H12.2812C12.799 10.4062 13.2188 10.826 13.2188 11.3438V16.0312M13.2188 2.4375V4.3125C13.2187 4.83027 12.799 5.25 12.2812 5.25L5.71875 5.25C5.20098 5.25 4.78125 4.83027 4.78125 4.3125L4.78125 1.5M16.0293 4.77927L13.2207 1.97073C12.9193 1.66933 12.5105 1.5 12.0843 1.5H3.10714C2.21953 1.5 1.5 2.21953 1.5 3.10714V14.8929C1.5 15.7805 2.21953 16.5 3.10714 16.5H14.8929C15.7805 16.5 16.5 15.7805 16.5 14.8929V5.91569C16.5 5.48945 16.3307 5.08067 16.0293 4.77927Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Save02.propTypes = {
  color: PropTypes.string,
};

export default Save02;
